import { Icon, IconProps, IconColorType } from '@octano/global-ui';
import { useMemo } from 'react';

export interface BadgeStateProps {
  status: string;
  text: string;
}
export default function DocumentBadgeState({ status, text }: BadgeStateProps) {
  const colors = useMemo<Record<string, IconColorType>>(() => {
    return {
      pending: 'warning',
      approved: 'success',
      rejected: 'danger',
    };
  }, []);

  const icon = useMemo<Record<string, IconProps['name']>>(() => {
    return {
      pending: 'circle',
      approved: 'success',
      rejected: 'error',
    };
  }, []);

  return (
    <>
      <div
        className="d-flex align-items-center justify-content-center student-degree-status-badge"
        style={{ gap: 5 }}
      >
        <Icon name={icon[status]} color={colors[status]} />
        <span>{text}</span>
      </div>
    </>
  );
}
